import React, { useContext } from 'react';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import OktaSSOLandingHelmet from 'common/helmets/OktaSSOLandingHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import OktaLogo from 'img/landing/okta-logo.webp';

import CannyLogoIcon from 'img/canny-icon.svg';

import 'css/components/_LandingFeatures.scss';
import 'css/components/integrations/_IntegrationsLanding.scss';

const OktaSSOLanding = () => {
  const showIntercom = useContext(ShowIntercomContext);

  return (
    <div className="integrationsLanding withoutImage">
      <OktaSSOLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={OktaLogo}
                alt="Okta Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Okta SSO Integration</h1>
              <p className="subtitle">
                Let your employees sign in to your company’s Canny account via your Okta
                organization.
              </p>
              <div className="links">
                <Button
                  buttonType="blackButton"
                  value="Contact us for access"
                  onTap={showIntercom}
                />
                <a
                  href="https://help.canny.io/en/articles/4029303-okta-sso-integration"
                  rel="noopener"
                  target="_blank">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Simple and secure authentication and provisioning</h2>
              <p className="subtitle">
                Easily manage which team members have Canny access in Okta. Let them log in using
                their Okta account.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default OktaSSOLanding;
